<script setup>
const props = defineProps({
  text: String,
  childClass: String,
  wrap: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['container', 'children'])

const containerElement = ref(null)

onMounted(() => {
  emit('container', containerElement.value)
  emit(
    'children',
    [...containerElement.value.children].flatMap((child) => [...child.children])
  )
})

const randomKey = (prefix) => `${prefix}-${Math.random().toString(36).substring(2, 15)}`

const wordsAndChars = computed(() => (props.text || '').split(' ').map((word, index, words) => word.split('').concat(index < words.length - 1 ? '&nbsp;' : [])))
</script>

<template>
  <div ref="containerElement" class="flex" :class="{ 'flex-wrap': wrap }">
    <div v-for="chars in wordsAndChars" :key="randomKey(chars.join(''))" class="flex" :class="{ 'flex-wrap': wrap }">
      <div v-for="char in chars" :key="randomKey(char)" class="text-center" :class="props.childClass" v-html="char" />
    </div>
  </div>
</template>
